<span [tiimeTooltip]="tag" tooltipHideWithoutEllipsis>
  {{ tag }}
</span>
